
/**
 * 宣传分类
 */

export const NewsCategoryList=[
    {
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false,
      },
      {
        prop: "name",
        label: "分类名称",
        width: "150",
        format: "",
        order: false,
        isShow: true,
      },
 ]

